import React from 'react'
import { Field } from 'formik'
import { Form, Col } from '_zari/core'

const DetalleProductoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='DETALLE' htmlFor='input-detalleProducto' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='detalleProducto'>
          {({ field }) => (
            <Form.TextArea
              {...field}
              rows={2}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='input-detalleProducto'
              placeholder='Detalle del producto'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DetalleProductoFormGroup)
